import carImages from '../data/carImages.json';

type ImageEntry = { modelFamily: string; image: string; matchType?: "exact" | "similar"; similarTo?: string };
const images: Record<string, ImageEntry> = carImages;

// Placeholder dels cotxes sense imatge confirmada: el cotxe tapat de carwow.
//
// És una còpia local, no una crida al CDN, perquè no hi ha cap manera neta de
// demanar-lo: si demanes una imatge sense make ni modelFamily, imagin.studio
// respon el cotxe tapat però amb "400: Bad Request" escrit al mig; l'única
// crida que el torna net és amb una marca inventada (`make=zzzz`), que és una
// resposta d'error no documentada i no s'hi pot confiar. El fitxer d'aquí ve
// justament d'aquella crida, desada un cop.
//
// Va a /cars/ perquè el servidor de dev només serveix aquestes carpetes de
// public/ (src/index.tsx); a l'arrel cauria al fallback de l'SPA.
export const DEFAULT_CAR_IMAGE = "/cars/placeholder.png";

// Entries are resolved at build time. Some use a verified same-brand model
// image when an exact model family is unavailable; see `matchType` in the data.
export const findModelImage = (brandId: string, modelId: string, _isDiscontinued: boolean = false): string => {
  const entry = images[`${brandId}/${modelId}`];
  return entry ? entry.image : DEFAULT_CAR_IMAGE;
};

export const isSimilarModelImage = (brandId: string, modelId: string): boolean =>
  images[`${brandId}/${modelId}`]?.matchType === "similar";

// Get higher resolution image by replacing width parameter
export const getHighResImage = (imageUrl: string, width: number = 400): string => {
  return imageUrl.replace(/width=\d+/, `width=${width}`);
};
